import { css } from "jquery";


$(function() {
  $('.sidebar-underlay').on('click', () => {
    $('.sidebar-opener').click();
  })

  $('.sidebar-opener').css('width', $('.ly-col-leftpane').outerWidth())
  
  $('.sidebar-opener').on('click', () => {
    var _this = $('.sidebar-opener');
    var sideBar = $('.ly-col-leftpane');
    var sidebarWidth = sideBar.outerWidth() * -1;
    var animated = false;

    if(!_this.hasClass('is-open')) {
      var offset = sideBar.css('left', sidebarWidth).offset().left + 50;

      sideBar.stop().animate({
        left: 0
      }, {
        duration: 1000, 
        easing: 'linear',
        step: function( now, fx ) {
          if(now >= offset && !animated) {
            _this.stop().animate({
              width: '75%'
            }, 840, 'linear')

            animated = true;
          }
        },
        complete: function() {
          _this.addClass('is-open');
        }
      })

      $('.sidebar-underlay').addClass('is-visible')
    } else {
      sideBar.stop().animate({
        left: sidebarWidth + "px"
      }, 1000, 'linear')

      _this.stop().animate({
        width: 50
      }, 840, 'linear')

      _this.removeClass('is-open');
      $('.sidebar-underlay').removeClass('is-visible')
    }
  })
});
